/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

import type { TabsLayoutProps } from "./types";

export default CustomPlatform.select<() => React.FC<TabsLayoutProps>>({
  native: () => require("./TabsLayout").default,
  androidTV: () => require("./TabsLayout.androidtv").default,
  tv: () => require("./TabsLayout.tv").default,
  web: () => require("./TabsLayout.web").default,
})();
